import routerOptions0 from "/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}